import { lazy, Suspense, type ReactElement } from 'react'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { RouterContext } from '~/router'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

const RouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtools,
      })),
    )
  : null

function RootComponent(): ReactElement {
  return (
    <>
      <Outlet />
      {RouterDevtools ? (
        <Suspense fallback={null}>
          <RouterDevtools position="bottom-right" />
        </Suspense>
      ) : null}
    </>
  )
}
